import { useTranslation } from 'react-i18next'

import { DbItemAdapter } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { SelectDropdown, SelectDropdownProps } from '@makyoapp/makyo-ui'

import { appIconKeys } from '@/shared/icons'

import { RenderColumnCustom } from './RenderColumn'

export interface DbDropdownProps extends Omit<SelectDropdownProps<DbItemAdapter>, 'renderOption' | 'optionLabel'> {
  options?: DbItemAdapter[]
}

export function DbDropdown(props: DbDropdownProps) {
  const { t } = useTranslation()

  return (
    <SelectDropdown
      {...props}
      optionLabel={(opt) => `${opt?.id} ${opt?.name}`}
      withSearch
      searchInputProps={{
        className: 'sdd-search-input font-normal',
        placeholder: t('Search'),
      }}
      renderOption={(opt) => {
        return (
          <RenderColumnCustom
            name={opt?.name}
            className='txt'
            textClassName='txt'
            icon={<MaterialIcon size={16} icon={appIconKeys.database} />}
          />
        )
      }}
    />
  )
}
